module.exports = __webpack_public_path__ + "static/media/icon_howToDispose_blue.e87fed71.svg";